var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { converYearMonthToString } from '../../services/dashboard';
import { Stack } from '@mui/material';
import { formatNumber } from '../../services/utils/utils';
Chart.register(CategoryScale);
var getCharData = function (config, datas) {
    var datasets = [];
    var _loop_1 = function (name_1, color, label, type) {
        datasets.push({
            label: label,
            data: datas.map(function (data) { return data[name_1]; }),
            backgroundColor: color,
            borderColor: color,
            type: type,
        });
    };
    for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
        var _a = config_1[_i], name_1 = _a.name, color = _a.color, label = _a.label, type = _a.type;
        _loop_1(name_1, color, label, type);
    }
    return {
        labels: datas.map(function (data) { return converYearMonthToString(data.Date); }),
        datasets: datasets,
    };
};
export var ChartBar = function (_a) {
    var datas = _a.datas, config = _a.config, _b = _a.isEuro, isEuro = _b === void 0 ? false : _b, _c = _a.onClick, onClick = _c === void 0 ? null : _c;
    var numberFormater = function (number) {
        return formatNumber(number, isEuro ? '€' : '', 0);
    };
    var chartData = getCharData(config, datas);
    var options = {
        plugins: {
            datalabels: {
                display: 'auto',
                formatter: function (value) {
                    return ''; //value ? numberFormater(value) : ''
                },
                font: { family: 'Quicksand, sans-serif', weight: 600 },
                textShadowColor: 'black',
                textShadowBlur: 0,
            },
            legend: {
                display: true,
                onClick: function (event, legendItem, legend) {
                    var index = legendItem.datasetIndex;
                    var chart = legend.chart;
                    if (chart.isDatasetVisible(index)) {
                        chart.hide(index);
                        legendItem.hidden = true;
                    }
                    else {
                        chart.show(index);
                        legendItem.hidden = false;
                    }
                    if (onClick) {
                        onClick(legendItem.datasetIndex);
                    }
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        var label = context.dataset.label ? " ".concat(context.dataset.label) : '';
                        if (label) {
                            label += ' : ';
                        }
                        label += numberFormater(context.dataset.data[context.dataIndex]);
                        return label;
                    },
                },
            },
        },
    };
    return (_jsx(Stack, __assign({ paddingX: 2 }, { children: _jsx(Bar, { data: chartData, options: options }) })));
};
//# sourceMappingURL=ChartBar.js.map